import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {compact, filter, find, map} from 'lodash';
import CollegeSuccess from '../components';
import {getCollegeSuccessItemTypes} from '../actions/college-success-item-types';

export const filterCompletedTypes = (collegeSuccessItemTypes, collegeSuccessItems, attendance) =>
  filter(collegeSuccessItemTypes, (type) => {
    if (type.allowMany) return true;

    switch (type.collegeSuccessItemType) {
      case 'FafsaSubmissionItem': {
        const item = find(collegeSuccessItems, {_type: 'FafsaSubmissionItem'});
        if (item) {
          return false;
        }
        break;
      }
      case 'TimeSensitiveItem': {
        const item = find(collegeSuccessItems, {
          _type: 'TimeSensitiveItem',
          timeSensitiveItemTypeId: type._id,
        });
        if (item) {
          return false;
        }
        break;
      }
      case 'PerfectAttendance': {
        const attendanceYears = compact(
          map(attendance, (absences, year) => {
            if (absences === 0) return year;
          })
        );

        if (attendanceYears.length) {
          return false;
        }
        break;
      }
    }

    return true;
  });

export const mapStateToProps = ({collegeSuccessItemTypes, collegeSuccessItems, attendance}) => ({
  collegeSuccessItemTypes: filterCompletedTypes(
    collegeSuccessItemTypes,
    collegeSuccessItems,
    attendance
  ),
  loading: collegeSuccessItemTypes.length === 0,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({getCollegeSuccessItemTypes}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CollegeSuccess);
